import { ia } from 'lib/helpers/utility';

export const formatNewIcdDataObj = ({ data, order_index, appointmentId }) => {
  return {
    label: data?.label || `${data?.icd10?.code} - ${data?.icd10?.name}`,
    value: data?.value || data?.icd_10_code_id,
    created_at: new Date().toISOString(),
    appointment_id: appointmentId,
    order_index: order_index || 0
  };
};

export const decimalIcdFormat = ({ data, single = true, databank = false }) => {
  const newData = single ? [data] : data;

  if (!ia(newData)) return data;

  const newDecimalFormatCodes = newData.map((item) => {
    const label = databank ? item?.code : item?.label;

    if (typeof label !== 'string') return item;

    const newLabel = label?.replace(/^(\s*[\w.]+)/, (match) => {
      const cleaned = match?.replace(/\./g, '')?.toUpperCase()?.trim();
      return cleaned.length <= 3 ? cleaned : `${cleaned?.slice(0, 3)}.${cleaned?.slice(3)}`;
    });

    return { ...item, ...(databank ? { code: newLabel } : { label: newLabel }) };
  });

  return single ? newDecimalFormatCodes[0] : newDecimalFormatCodes;
};

export const formatIcdCode = (code) =>
  typeof code === 'string' ? decimalIcdFormat({ data: { label: code } }).label : code;

export const revertDecimalIcdFormat = (label) => {
  if (typeof label !== 'string') return label;

  return label.replace(/^([\s]*)([\w]+\.[\w]*)(.*)$/i, (_, leadWs, codePart, rest) => {
    const cleanCode = codePart?.replace(/\./g, '').toUpperCase();
    return leadWs + cleanCode + rest;
  });
};
